import React from 'react';
import { Box, Typography } from '@mui/material';
import { TOKEN_COLOR } from './tokens';

// Row heading above a group of KPI cards: bold uppercase title, muted hint, then a rule to the right.
export default function SectionTitle({ title, hint }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25 }}>
            <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: '#555', whiteSpace: 'nowrap' }}>
                {title}
            </Typography>
            {hint && <Typography sx={{ fontSize: '11px', color: TOKEN_COLOR.textMuted }}>{hint}</Typography>}
            <Box sx={{ flex: 1, height: '1px', bgcolor: '#e0e0e0' }} />
        </Box>
    );
}
